export default {
  unavailable: {
    title: 'El acceso de autoservicio para partners es limitado',
    description:
      'Esta sección no está disponible para socios en incorporación de autoservicio. Contacta a tu gestor de cuenta si la necesitas.',
  },
};
